var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsAppSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_122)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.947 112.317L159.535 110.312C165.877 122.015 164.15 137.027 154.792 147.462C148.36 154.63 139.05 158.5 129.585 158.5C124.795 158.506 120.058 157.504 115.68 155.56L116.715 153.315C129.115 158.84 144 155.765 152.915 145.83C161.703 136.03 163.237 121.872 157.067 110.995L156.305 116.302L153.822 115.957L155.062 107.312C155.091 107.121 155.164 106.939 155.276 106.781C155.387 106.623 155.534 106.493 155.705 106.402C155.877 106.311 156.068 106.259 156.263 106.253C156.458 106.246 156.652 106.285 156.83 106.365L165 110.08L163.947 112.317ZM107.188 106.155C98.3675 115.992 96.8825 128.19 102.97 138.687L103.68 133.232L106.168 133.545L105.017 142.382C104.992 142.577 104.92 142.763 104.808 142.925C104.696 143.086 104.546 143.218 104.372 143.31C104.197 143.403 104.003 143.454 103.805 143.459C103.606 143.464 103.409 143.422 103.23 143.337L95 139.432L96.0875 137.212L100.438 139.275C94.2125 127.985 95.905 115.007 105.308 104.525C114.925 93.805 130.97 90.48 144.3 96.425L143.265 98.67C130.912 93.16 116.08 96.245 107.185 106.155H107.188ZM116.023 134.725C116.023 133.025 117.425 131.642 119.155 131.642C120.882 131.642 122.29 133.025 122.29 134.725C122.29 136.425 120.882 137.807 119.155 137.807C118.331 137.813 117.538 137.492 116.951 136.914C116.364 136.336 116.03 135.549 116.023 134.725ZM129.222 119.757C129.73 119.902 130.255 120.007 130.802 120.007C131.32 120.007 131.812 119.915 132.285 119.787L137.483 130.287C136.409 131.065 135.65 132.202 135.345 133.492H124.645C124.345 132.234 123.614 131.12 122.578 130.345L129.225 119.757H129.222ZM130.802 111.372C132.532 111.372 133.94 112.757 133.94 114.455C133.94 116.155 132.532 117.54 130.802 117.54C129.077 117.54 127.67 116.157 127.67 114.455C127.67 112.755 129.075 111.372 130.802 111.372ZM143.965 134.722C143.965 136.425 142.563 137.807 140.833 137.807C139.105 137.807 137.698 136.425 137.698 134.725C137.698 133.025 139.105 131.642 140.833 131.642C142.563 131.642 143.965 133.022 143.965 134.722ZM124.643 135.957H135.342C135.638 137.19 136.34 138.287 137.337 139.07C138.333 139.853 139.565 140.277 140.833 140.272C143.943 140.272 146.473 137.785 146.473 134.722C146.473 131.667 143.943 129.177 140.833 129.177C140.468 129.177 140.115 129.217 139.773 129.282L134.497 118.62C135.682 117.602 136.448 116.122 136.448 114.455C136.448 111.395 133.915 108.907 130.802 108.907C127.695 108.907 125.163 111.395 125.163 114.457C125.163 116.082 125.893 117.535 127.03 118.552L120.293 129.29C119.918 129.215 119.537 129.177 119.155 129.177C116.047 129.177 113.515 131.667 113.515 134.725C113.515 137.785 116.047 140.275 119.155 140.275C120.422 140.279 121.654 139.854 122.65 139.071C123.646 138.287 124.348 137.19 124.643 135.957Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_122",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_122",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F8B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsAppSync);
export default __webpack_public_path__ + "static/media/aws-app-sync.5b80fa4605b4b72d03cc01d7bdc4d9c1.svg";
export { ForwardRef as ReactComponent };